// THE REBUILT CONSOLE'S PALETTE SWITCH (UI rebuild, 26 Oct 2026). With batch 1 off nothing here runs and the
// console keeps main's palette (the :root values in styles.css). With it on, <html> carries `ui-v2` — every colour
// variable takes Astra's palette — and `ui-light` when this build's theme is light (lib/ui-v2.ts; dark while the
// operator's answer on the theme is open).

import { uiV2, UI_THEME } from './ui-v2';

export function bootTheme(): void {
  if (!uiV2(1)) return;
  const root = document.documentElement;
  root.classList.add('ui-v2');
  root.classList.toggle('ui-light', UI_THEME === 'light');
  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta) meta.setAttribute('content', UI_THEME === 'light' ? '#f5f6f8' : '#101720');
}
